import {LoyaltyMode} from '@shopping-angular-components/loyalty';
import {Points} from '../shared/models/domain/loyalty/points';

export class PointsInfoUtils {
    public static getPoints(pointsInfo: Points, loyaltyMode: LoyaltyMode): number {
        switch (loyaltyMode) {
            case LoyaltyMode.ACQUISITION:
                return pointsInfo.totalAccrualPoints;
            case LoyaltyMode.ACCUMULATION:
                return pointsInfo.totalAccrualPoints;
            case LoyaltyMode.REDEMPTION:
                return pointsInfo.redemption.partialAccrualPoints;
            default:
                console.log('Returning default totalAmount');
                return pointsInfo.totalAccrualPoints;
        }
    }
}
